import { defineComponent as _defineComponent } from 'vue'
import device from '@@/bits/device'
import OzFocusTrap from '@@/library/v4/components/OzFocusTrap.vue'
import { overlayHide, overlayShow } from '@@/native_bridge/actions'
import postMessage from '@@/native_bridge/post_message'
import { uniqueId } from 'lodash-es'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzOverlay',
  props: {
    scrim: { default: 'modal' },
    darkMode: { type: [Boolean, String], default: 'auto' },
    shouldFadeIn: { type: Boolean, default: true },
    isSpectral: { type: Boolean, default: false },
    position: { default: 'fixed' },
    zIndexClass: { default: 'z-modal2' }
  },
  emits: ['scrim-click', 'scrim-esc'],
  setup(__props: any, { emit }) {

const props = __props as { scrim: 'modal' | 'popover' | null, darkMode: true | false | 'auto', shouldFadeIn: boolean, isSpectral: boolean, position: 'fixed' | 'absolute', zIndexClass: 'z-modal2' | 'z-sidepanel' | 'z-dropdown' | 'z-modal-dropdown' | 'z-mentions-box' | 'z-alert' }




const mouseDownTarget = ref<EventTarget | null>(null)
const mouseUpTarget = ref<EventTarget | null>(null)
const focusTrapDescriptionId = uniqueId('focusTrap')

const overlayClasses = computed(() => [
  // Covers other elements on page
  props.position,
  'inset-0',
  props.zIndexClass,
  // Transitions
  { fade: props.shouldFadeIn },

  // Scrim
  props.scrim === 'modal' && {
    'bg-modal-overlay-light': props.darkMode === false,
    'bg-modal-overlay-dark': props.darkMode === true,
    'bg-modal-overlay-light dark:bg-modal-overlay-dark': props.darkMode === 'auto',
  },
  props.scrim === 'popover' && {
    'bg-popover-overlay-light': props.darkMode === false,
    'bg-popover-overlay-dark': props.darkMode === true,
    'bg-popover-overlay-light dark:bg-popover-overlay-dark': props.darkMode === 'auto',
  },

  // Misc
  'touch-action-manipulation',
])

// These colors are taken from the TW config.
const overlayColor = computed(() =>
  props.scrim === 'modal'
    ? props.darkMode === true
      ? 'rgba(36, 37, 39, 0.8)' // modal-overlay-dark | modal-overlay-light
      : 'rgba(0, 0, 0, 0.2)'
    : props.scrim === 'popover'
    ? props.darkMode === true
      ? 'rgba(255, 255, 255, 0.05)' // popover-overlay-dark | popover-overlay-light
      : 'rgba(0, 0, 0, 0.15)'
    : 'transparent',
)

const scrimClick = (e: MouseEvent) => {
  // Emits if and only if the mouse down and mouse up events
  // are both on the same element and is outside of the overlay.
  // This ensures click and drag between overlay does not hide overlay.
  if (mouseDownTarget.value === mouseUpTarget.value && mouseDownTarget.value === e.target) {
    /**
     * Emitted with overlay scrim is clicked. Can be used to trigger closure of drawer.
     */
    emit('scrim-click')
  }
}
/**
 * Emitted when an escape keydown event is propagated to the overlay.
 * Since focus is trapped, it is effectively a global listener.
 */
const scrimEsc = () => {
  emit('scrim-esc')
}

const mouseDown = (e: MouseEvent) => {
  mouseDownTarget.value = e.target
}

const mouseUp = (e: MouseEvent) => {
  mouseUpTarget.value = e.target
}

onMounted(() => {
  if (device.app && props.scrim !== null) {
    postMessage(
      overlayShow({
        overlayColor: overlayColor.value,
      }),
    )
  }
})

onBeforeUnmount(() => {
  if (device.app && props.scrim !== null) {
    postMessage(overlayHide())
  }
})

return { __sfc: true,props, emit, mouseDownTarget, mouseUpTarget, focusTrapDescriptionId, overlayClasses, overlayColor, scrimClick, scrimEsc, mouseDown, mouseUp, OzFocusTrap }
}

})